import React from 'react'

const ImpressumDE = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: 'ol{margin:0;padding:0}table td,table th{padding:0}.c3{background-color:#ffffff;padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c12{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c1{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c2{background-color:#ffffff;padding-top:10pt;padding-bottom:10pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c0{color:#222323;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c14{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:26pt;font-family:"Albert Sans";font-style:normal}.c10{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c7{text-decoration-skip-ink:none;font-size:12pt;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline}.c6{font-weight:700;text-decoration:none;vertical-align:baseline;font-family:"Albert Sans";font-style:normal}.c8{background-color:#ffffff;max-width:451.4pt;padding:72pt 72pt 72pt 72pt}.c13{font-size:12pt;color:#0a0a0a}.c4{color:#222323;font-size:12pt}.c5{color:inherit;text-decoration:inherit}.c9{height:11pt}.c11{background-color:#ffffff}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c10">
                <span className="c12">Impressum</span>
            </p>
            <p className="c10">
                <span className="c12">Stand: April 2024</span>
            </p>
            <p className="c3">
                <span className="c0">Wemolo GmbH</span>
            </p>
            <p className="c3">
                <span className="c0">St.-Martin-Straße 72</span>
            </p>
            <p className="c3">
                <span className="c0">81541 München</span>
            </p>
            <p className="c3">
                <span className="c0">Deutschland</span>
            </p>
            <p className="c3 c9">
                <span className="c0" />
            </p>
            <p className="c3">
                <span className="c7 c11">
                    <a className="c5" href="mailto:help@wemolo.com">
                        help@wemolo.com
                    </a>
                </span>
                <span className="c11 c13">&nbsp;</span>
            </p>
            <p className="c3">
                <span className="c0">Tel.: +49 89 6931 464 91</span>
            </p>
            <p className="c3">
                <span className="c4">Website: </span>
                <span className="c7">
                    <a className="c5" href="https://www.wemolo.com">
                        www.wemolo.com
                    </a>
                </span>
                <span className="c0">&nbsp;</span>
            </p>
            <p className="c2">
                <span className="c0">
                    Vertreten durch die Geschäftsführer: Jakob Bodenmüller, Yukio Iwamoto, Bastian Pieper
                </span>
            </p>
            <p className="c3">
                <span className="c0">Firmensitz: München</span>
            </p>
            <p className="c3">
                <span className="c0">Registergericht: Amtsgericht München</span>
            </p>
            <p className="c3">
                <span className="c0">Registernummer: HRB 250653</span>
            </p>
            <p className="c3">
                <span className="c0">Umsatzsteuer-Identifikationsnummer: DE325788012</span>
            </p>
            <p className="c2">
                <span className="c0">
                    Hinweis: Dieses Impressum gilt für alle von Wemolo betriebenen Websites, insbesondere die oben
                    genannte Website sowie der Blog und Help Center von Wemolo sowie die webbasierte Software.
                </span>
            </p>
            <p className="c2">
                <span className="c4 c6">Haftung für Inhalte</span>
            </p>
            <p className="c2">
                <span className="c0">
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
                    Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als
                    Dienstleister sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                    verantwortlich. Jedoch sind wir nicht verpflichtet, übermittelte oder gespeicherte fremde
                    Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                    hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                    allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                    Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
                    entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </span>
            </p>
            <p className="c2">
                <span className="c6 c4">Urheberrecht</span>
            </p>
            <p className="c2">
                <span className="c0">
                    Die Inhalte dieser Website unterliegen dem Urheberrecht, sofern nicht anders gekennzeichnet, und
                    dürfen nicht ohne vorherige schriftliche Zustimmung von Wemolo weder als Ganzes noch in Teilen
                    verbreitet, verändert oder kopiert{' '}
                </span>
            </p>
            <p className="c2">
                <span className="c0">
                    werden. Die auf dieser Website eingebundenen Bilder dürfen nicht ohne vorherige schriftliche
                    Zustimmung von Wemolo verwendet werden. Auf den Websites enthaltene Bilder unterliegen teilweise dem
                    Urheberrecht Dritter. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
                    werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
                    gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir
                    um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
                    Inhalte umgehend entfernen.
                </span>
            </p>
            <p className="c2">
                <span className="c6 c4">Haftung für Links</span>
            </p>
            <p className="c2">
                <span className="c0">
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss
                    haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
                    der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
                    verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                    Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
                    inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
                    Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                    umgehend entfernen.
                </span>
            </p>
            <p className="c2">
                <span className="c6 c4">Verantwortlicher</span>
            </p>
            <p className="c3">
                <span className="c0">Jakob Bodenmüller (Geschäftsführer)</span>
            </p>
            <p className="c3">
                <span className="c0">St.-Martin-Straße 72</span>
            </p>
            <p className="c3">
                <span className="c0">81541 München, Deutschland</span>
            </p>
            <p className="c3">
                <span className="c0">Tel.: +49 (0) 89 356477 60</span>
            </p>
            <p className="c3">
                <span className="c4">E-Mail: </span>
                <span className="c7 c11">
                    <a className="c5" href="mailto:help@wemolo.com">
                        help@wemolo.com
                    </a>
                </span>
                <span className="c13 c11">&nbsp;</span>
            </p>
            <p className="c2">
                <span className="c6 c4">Zuständige Aufsichtsbehörde bei Datenschutzbeschwerden</span>
            </p>
            <p className="c3">
                <span className="c0">Bayerisches Landesamt für Datenschutzaufsicht</span>
            </p>
            <p className="c3">
                <span className="c0">Postfach 1349</span>
            </p>
            <p className="c3">
                <span className="c0">91504 Ansbach, Deutschland</span>
            </p>
            <p className="c2 c9">
                <span className="c0" />
            </p>
        </>
    )
}

export default ImpressumDE
